import type { ValueOf } from 'types';
import { APP_TYPE, REQUEST_STATUSES, URL_APP_TYPE } from 'consts';

const LOGIQUANTA_OR_FLS_DOMAIN = 'haulageexchange.co.uk';

export const isLogiquantaOrFlsDomain = () => {
    const hostname = globalThis.location.hostname;

    if (hostname.includes(LOGIQUANTA_OR_FLS_DOMAIN)) {
        return (
            hostname.startsWith(URL_APP_TYPE[APP_TYPE.LOGIQUANTA]) || hostname.startsWith(URL_APP_TYPE[APP_TYPE.FLS])
        );
    }

    return false;
};

export const queryParams = (search: string) => (key: string) => () => new URLSearchParams(search).get(key);
const querySearchParams = queryParams(globalThis.location.search);
export const checkFlsAppTypeByDomain = () => globalThis.location.origin.includes('fls');
export const queryAppType = () => {
    if (isLogiquantaOrFlsDomain()) {
        return globalThis.location.hostname.split('.')[0];
    }

    const appParam = querySearchParams('app')();

    if (appParam === 'integra') {
        const searchParams = new URLSearchParams(globalThis.location.search);
        searchParams.set('app', 'teg');
        globalThis.location.search = searchParams.toString();
        return 'teg';
    }

    return appParam;
};

export const validateAppType =
    (types: ValueOf<typeof URL_APP_TYPE>[]) =>
    (appType: string | null | undefined) =>
    (): ValueOf<typeof URL_APP_TYPE> => {
        const isFlsAppType = checkFlsAppTypeByDomain();

        if (isFlsAppType) {
            return URL_APP_TYPE[APP_TYPE.FLS];
        }

        const isDefault = !appType || !(types as string[]).includes(appType);

        return isDefault ? URL_APP_TYPE[APP_TYPE.CX] : (appType as ValueOf<typeof URL_APP_TYPE>);
    };

export const getAppType = validateAppType(Object.values(URL_APP_TYPE))(queryAppType());

export const createDefaultMeta = (appType: ValueOf<typeof URL_APP_TYPE>) => () => ({
    meta: null,
    status: REQUEST_STATUSES.NOT_STARTED,
    appType,
});
